import {
	Box,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TablePagination,
	TableRow,
} from "@mui/material";
import {
	flexRender,
	getCoreRowModel,
	getPaginationRowModel,
	useReactTable,
} from "@tanstack/react-table";
import React from "react";

import { AiQualityToolProvider } from "../../../context/AiQualityToolContext";
import { AttachmentAnalyze } from "../attachment-analyze";
import { ContentAnalyze } from "../content-analyze";

export const ImapTable = ({ data, paginationState }) => {
	// const columns = React.useMemo(
	// 	() => [
	// 		{
	// 			header: "Temat",
	// 			accessorKey: "subject",
	// 		},
	// 		{
	// 			header: "Treść",
	// 			accessorKey: "body",
	// 			cell: ({ row }) => {
	// 				const body = row.original.body;
	// 				const excerpt = body.slice(0, 80);

	// 				return excerpt + "...";
	// 			},
	// 		},
	// 		{
	// 			id: "actions",
	// 			header: "Akcje",
	// 			cell: ({ row }) => {
	// 				const cargoId = row.original.id;
	// 				const status = row.original.status;
	// 				const publicNote = row.original.publicNote;
	// 				const privateNote = row.original.privateNote;

	// 				return (
	// 					<Box
	// 						sx={{
	// 							position: "relative",
	// 							display: "flex",
	// 							gap: "6px",
	// 						}}
	// 					>
	// 						<AttachmentsAnalyze />
	// 						<ContentAnalyze />
	// 					</Box>
	// 				);
	// 			},
	// 		},
	// 	],
	// 	[data]
	// );

	const columns = [
		{
			header: "Temat",
			accessorKey: "subject",
		},
		{
			header: "Treść",
			accessorKey: "body",
			cell: ({ row }) => {
				console.log("row.original", row.original);
				const body = row.original.body;
				const excerpt = body.slice(0, 80);

				return excerpt + "...";
			},
		},
		{
			header: "Załączników",
			accessorKey: "attachments",
			cell: ({ row }) => {
				const attachments = row.original.attachments;

				return attachments.length;
			},
		},
		{
			id: "actions",
			header: "Akcje",
			cell: ({ row }) => {
				const attachments = row.original.attachments;
				const content = row.original.body;

				return (
					<Box
						sx={{
							position: "relative",
							display: "flex",
							gap: "6px",
						}}
					>
						<AttachmentAnalyze
							disabled={attachments.length <= 0}
							emailId={row.original.id}
						/>
						<ContentAnalyze content={content} />
					</Box>
				);
			},
		},
	];

	const table = useReactTable({
		data,
		columns,
		getRowId: (row) => row.id,
		getCoreRowModel: getCoreRowModel(),
		rowCount: paginationState.total,
		manualPagination: true,
		getPaginationRowModel: getPaginationRowModel(),
		onPaginationChange: paginationState.setPagination,
		state: {
			pagination: paginationState.pagination,
		},
	});
	return (
		<AiQualityToolProvider>
			<Table>
				<TableHead>
					{table.getHeaderGroups().map((headerGroup) => (
						<TableRow key={`table-row-${headerGroup.id}`}>
							{headerGroup.headers.map((header, index) => {
								return (
									<TableCell
										key={`table-th-${header.id}`}
										component="th"
										sx={{
											padding: "3px 12px",
											width:
												index === columns.length - 1 ||
												index === columns.length - 2
													? "1%"
													: "auto",
											textAlign:
												index === columns.length - 1 ||
												index === columns.length - 2
													? "center"
													: "",
										}}
									>
										{header.isPlaceholder
											? null
											: flexRender(
													header.column.columnDef.header,
													header.getContext()
											  )}
									</TableCell>
								);
							})}
						</TableRow>
					))}
				</TableHead>
				<TableBody>
					{table.getRowModel().rows?.length ? (
						table.getRowModel().rows.map((row) => (
							<>
								<TableRow
									key={`row-${row.id}`}
									sx={{
										position: "relative",
										...(row.getCanExpand() && {
											cursor: "pointer",
										}),
										...(row.getIsSelected() && {
											background: "#fffee8",
										}),
									}}
								>
									{row.getVisibleCells().map((cell, index) => {
										return (
											<TableCell
												key={`cell-${cell.id}`}
												sx={{
													textAlign:
														index === columns.length - 1 ||
														index === columns.length - 2
															? "center"
															: "",
												}}
											>
												{flexRender(
													cell.column.columnDef.cell,
													cell.getContext()
												)}
											</TableCell>
										);
									})}
								</TableRow>
							</>
						))
					) : (
						<h1>BRAK DANYCH</h1>
					)}
				</TableBody>
			</Table>
			<TablePagination
				component="div"
				count={paginationState.total} // Total number of rows in the table
				rowsPerPageOptions={[20, 50, 100]} // Options for rows per page
				rowsPerPage={table.getState().pagination.pageSize} // Current page size
				page={table.getState().pagination.pageIndex} // Current page index (0-based)
				onPageChange={(event, newPage) => {
					table.setPageIndex(newPage); // Set the new page index
				}}
				onRowsPerPageChange={(event) => {
					table.setPageSize(Number(event.target.value)); // Set the new page size
				}}
				labelRowsPerPage="Wiersze na stronę"
				labelDisplayedRows={({ from, to, count }) =>
					`${from}–${to} z ${count !== -1 ? count : `więcej niż ${to}`}`
				}
			/>
		</AiQualityToolProvider>
	);
};
